import { CheckCircleOutlineRounded } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Switch,
  Typography,
} from '@mui/material';
import React from 'react';

interface ModalCloseThemesProps {
  open: boolean;
  onClose: () => void;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ModalSuccessInvite = ({
  open,
  onClose,
  onCancel,
  onConfirm,
}: ModalCloseThemesProps) => {
  return (
    <Dialog open={open} PaperProps={{ style: { padding: '20px' } }}>
      <Box
        display="flex"
        flexDirection="column"
        gap="15px"
        alignItems="center"
        justifyContent="center"
      >
        <CheckCircleOutlineRounded
          color="success"
          sx={{ width: '61px', height: '61px' }}
        />
        <DialogTitle
          sx={{
            color: '#4CAF50',
            fontWeight: '700',
            fontSize: '24px',
            padding: '0',
            marginBottom: '20px',
          }}
        >
          Invite enviado com sucesso!
        </DialogTitle>
      </Box>
      <DialogContent sx={{ padding: '0' }}>
        <DialogContentText
          id="alert-dialog-description"
          sx={{
            fontWeight: '400',
            fontFamily: 'Roboto',
            fontSize: '16px',
            color: 'rgba(0, 0, 0, 0.54)',
            padding: '0',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '15px',
          }}
        >
          <Typography
            sx={{
              textAlign: 'center',
            }}
          >
            Todos os participantes receberão o e-mail com invite.
          </Typography>
          <Typography
            sx={{
              textAlign: 'center',
            }}
          >
            Essa ação só é necessária uma vez, portanto o botão de criar invite
            não estará mais disponível.
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          padding: '0',
          marginTop: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Button
          onClick={onConfirm}
          autoFocus
          variant="text"
          sx={{
            color: '#9E9E9E',
            fontWeight: '500',
            fontSize: '14px',
            padding: '6px 22px',
          }}
        >
          Ok, fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
